import { Pipe, PipeTransform } from '@angular/core';
import { format, ParsedNumber } from 'libphonenumber-js';

@Pipe({
  name: 'telephone'
})
export class TelephonePipe implements PipeTransform {
  transform(value: string, args?: string): any {
    if (!value) {
      return value;
    }

    value = value.replace(/[^\w\s]/gi, '');

    return format(value, 'US', 'National');
  }
}
